import * as React from 'react';
import Box from '@mui/material/Box';
import Popper from '@mui/material/Popper';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Box": Box, "@mui/material/Popper": Popper } } });
export default ClientProvider;
